import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PracticeInfo, State, SessionState, RQGenericResponse, Dispatch } from 'types';
import { getPractice } from 'modules/practice';
import { fetchCurrentPatient as fetchCurrentPatientAction } from 'modules/patient';
import AccountHeader from 'views/account/AccountHeader';

type OwnProps = {
  practiceId: number;
};

type StateProps = {
  practice: PracticeInfo;
  session: SessionState;
};

type DispatchProps = {
  fetchCurrentPatient: () => Promise<RQGenericResponse>;
};

type Props = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => ({
  practice: getPractice(state, ownProps),
  session: state.session,
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: OwnProps): DispatchProps => ({
  fetchCurrentPatient: (): Promise<RQGenericResponse> =>
    dispatch(fetchCurrentPatientAction(ownProps.practiceId)),
});

const BookingHeader: React.FC<Props> = ({ fetchCurrentPatient, practice, practiceId, session }) => {
  useEffect((): void => {
    if (!(session.activeUserId && session.activeChartId) && window.el8Globals.USER_ID) {
      fetchCurrentPatient();
    }
    // If users load the booking site and they have an active session, we want to load user data.
    // So this hook should only run once after initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let homeUrl;
  if (practice) {
    homeUrl = `/book/${practice.settings.slug}`;
  }

  return <AccountHeader homeUrl={homeUrl} practiceId={practiceId} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingHeader);
